import { getApiBaseUrl, getApiClient } from './serviceconfig';

const apiBaseUrl = getApiBaseUrl();

export async function getReceiptVoucherNumber(cookies, plantId, receiptDate) {
    const url = `${apiBaseUrl}/receipt_vouchers/receipt_voucher_number/?plant_id=${plantId}&receipt_date=${receiptDate}`;
    return getApiClient(cookies).get(url).then((r) => r.data);
}

export async function getReceiptVouchers(cookies, params = {}) {
    const query = new URLSearchParams(params).toString();
    return getApiClient(cookies).get(`${apiBaseUrl}/receipt_vouchers/${query ? `?${query}` : ''}`).then((r) => r.data);
}

export async function getReceiptVoucherDetails(cookies, id) {
    return getApiClient(cookies).get(`${apiBaseUrl}/receipt_vouchers/${id}/`).then((r) => r.data);
}

export async function getInvoicesForReceiptVoucher(cookies, plantId, customerId, excludeReceiptId = '') {
    let url = `${apiBaseUrl}/receipt_vouchers/invoices_for_customer/?plant_id=${plantId}&customer_id=${customerId}`;
    if (excludeReceiptId) url += `&exclude_receipt_id=${excludeReceiptId}`;
    return getApiClient(cookies).get(url).then((r) => r.data);
}

export function createReceiptVoucher(cookies, payload) {
    return getApiClient(cookies).post(`${apiBaseUrl}/receipt_vouchers/`, payload).then((r) => r.data);
}

export function updateReceiptVoucher(cookies, id, payload) {
    return getApiClient(cookies).put(`${apiBaseUrl}/receipt_vouchers/${id}/`, payload).then((r) => r.data);
}

export function cancelReceiptVoucher(cookies, id) {
    return getApiClient(cookies).patch(`${apiBaseUrl}/receipt_vouchers/${id}/`, {}).then((r) => r.data);
}

export function deleteReceiptVoucher(cookies, id) {
    return getApiClient(cookies).delete(`${apiBaseUrl}/receipt_vouchers/${id}/`).then((r) => r.data);
}

export async function printReceiptVoucher(cookies, receiptId) {
    return getApiClient(cookies).get(`${apiBaseUrl}/receipt_vouchers/${receiptId}/print_receipt_voucher/`, {
        responseType: 'blob',
    }).then((response) => response.data);
}
